import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Restore newlines in pipe-tables that were flattened into one line:
 * `| A | B | | --- | --- | | C | D |` → proper multiline GFM table.
 */
export const normalizeMarkdownTables = (source) => {
  if (!source || typeof source !== 'string') {
    return source || '';
  }

  if (!source.includes('|') || !/\|[ \t]*:?-{3,}:?[ \t]*\|/.test(source)) {
    return source;
  }

  return source.replace(/\|[ \t]+\|[ \t]*(?=\S)/g, '|\n| ');
};

const MarkdownView = ({ children, className = 'markdown-preview' }) => {
  const source = normalizeMarkdownTables(children || '');

  if (!source.trim()) {
    return null;
  }

  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {source}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownView;
